import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placement", "icon", "hidden", "background", "pageBackground", "contentClassName", "hasBorder", "borderColor", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var getBorderColorFromBg = function getBorderColorFromBg(bg) {
  return bg.replace('bg', 'border-color');
};
var RuleConnector = function RuleConnector(props) {
  var placement = props.placement,
    icon = props.icon,
    hidden = props.hidden,
    background = props.background,
    pageBackground = props.pageBackground,
    contentClassName = props.contentClassName,
    hasBorder = props.hasBorder,
    borderColor = props.borderColor,
    className = props.className,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var wrapperClassNames = classNames('RuleConnector', 'height-20', 'display-flex', "justify-content-".concat(placement), 'align-items-center', 'position-relative', hidden && 'opacity-0', className);
  var commonRoundedClasses = classNames('width-20', 'height-20', 'rounded-circle', 'position-relative', 'z-index-2', 'box-sizing-content-box');
  var commonRoundedBorderClippingClasses = classNames('position-relative', 'width-20', 'height-20');
  var leftRoundedBox = classNames('margin-right--10', commonRoundedClasses, pageBackground, hasBorder && "border ".concat(borderColor));
  var leftRoundedBoxBorderClipping = classNames('right-50pct', commonRoundedBorderClippingClasses, pageBackground);
  var contentWrapperClassNames = classNames('padding-left-20 padding-right-20', 'z-index-1', background, hasBorder && "border ".concat(getBorderColorFromBg(background)));
  var rightRoundedBox = classNames('margin-left--10', commonRoundedClasses, pageBackground, hasBorder && "border ".concat(borderColor));
  var rightRoundedBoxBorderClipping = classNames('left-50pct', commonRoundedBorderClippingClasses, pageBackground);
  return /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "ruleConnector"
  }, remainingProps, {
    className: wrapperClassNames
  }), /*#__PURE__*/React.createElement("div", {
    className: leftRoundedBox
  }, /*#__PURE__*/React.createElement("div", {
    className: leftRoundedBoxBorderClipping
  })), /*#__PURE__*/React.createElement("span", {
    className: contentWrapperClassNames
  }, /*#__PURE__*/React.createElement("span", {
    className: contentClassName
  }, children ? children : /*#__PURE__*/React.createElement("span", {
    className: "rioglyph ".concat(icon),
    "data-testid": "ruleConnectorIcon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: rightRoundedBox
  }, /*#__PURE__*/React.createElement("div", {
    className: rightRoundedBoxBorderClipping
  })));
};
RuleConnector.START = 'start';
RuleConnector.CENTER = 'center';
RuleConnector.END = 'end';
RuleConnector.defaultProps = {
  placement: 'center',
  icon: 'rioglyph-plus',
  hidden: false,
  background: 'bg-lightest',
  pageBackground: 'bg-white',
  contentClassName: 'text-color-light',
  hasBorder: false,
  borderColor: '',
  className: ''
};
RuleConnector.propTypes = {
  placement: PropTypes.oneOf([RuleConnector.START, RuleConnector.CENTER, RuleConnector.END]),
  icon: PropTypes.string,
  hidden: PropTypes.bool,
  background: PropTypes.string,
  pageBackground: PropTypes.string,
  contentClassName: PropTypes.string,
  hasBorder: PropTypes.bool,
  borderColor: PropTypes.string,
  className: PropTypes.string
};
export default RuleConnector;